import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  email,
  required,
  strongPassword,
} from '../../../../antd/form/FormValidation.js';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import FormPasswordField from '../../../../antd/form/FormPasswordField/FormPasswordField.jsx';
import Form from '../../../../antd/form/Form/Form.jsx';

const ForgottenPasswordForm = ({ onSubmit, form, isEmail }) => {
  const { t } = useTranslation();

  // State just to mark reCAPTCHA readiness
  const [, setGrecaptchaReady] = useState(false);

  // Načítanie reCAPTCHA skriptu
  useEffect(() => {
    let script;

    if (!window.grecaptcha) {
      script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${import.meta.env.VITE_RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        window.grecaptcha.ready(() => setGrecaptchaReady(true));
        // Zobraz badge ak existuje
        const badge = document.querySelector('.grecaptcha-badge');
        if (badge) badge.style.display = '';
      };
      document.body.appendChild(script);
    } else {
      window.grecaptcha.ready(() => setGrecaptchaReady(true));
      // Zobraz badge ak existuje
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) badge.style.display = '';
    }

    return () => {
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) badge.style.display = 'none';
      if (script) document.body.removeChild(script);
    };
  }, []);

  // Skry ikony pri zobrazení Form
  useEffect(() => {
    const elements = document.getElementsByClassName(
      'application-questions-container',
    );
    const prevDisplays = [];
    for (let i = 0; i < elements.length; i++) {
      prevDisplays[i] = elements[i].style.display;
      elements[i].style.display = 'none';
    }
    return () => {
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = prevDisplays[i] || '';
      }
    };
  }, []);

  const handleSubmit = (values) => {
    const cleanedValues = {
      ...values,
    };
    if (!window.grecaptcha) {
      onSubmit(cleanedValues);
      return;
    }

    window.grecaptcha.ready(() => {
      // reCAPTCHA execute vracia Promise s tokenom
      window.grecaptcha
        .execute(import.meta.env.VITE_RECAPTCHA_SITE_KEY, {
          action: 'forgotten_password',
        })
        .then((token) => {
          onSubmit({ ...values, captchaResponse: token });
        });
    });
  };

  if (isEmail) {
    return (
      <Form form={form} onFinish={handleSubmit}>
        <FormTextField
          label={t('Email')}
          name="email"
          extra={t(
            'Zadajte emailovú adresu, na ktorú vám bude zaslaný odkaz na obnovenie hesla. Váš účet musí byť registrovaný na portáli FRI.',
          )}
          rules={[required(t), email(t)]}
        />
        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey="ext_users">
            {t('Odoslať')}
          </FormButton>
        </FormButtonsContainer>
      </Form>
    );
  } else {
    return (
      <Form form={form} onFinish={handleSubmit}>
        <FormPasswordField
          label={t('Nové heslo')}
          name="password"
          extra={t(
            'Zadajte nové heslo, ktoré bude použité na prihlásenie do vášho účtu. Heslo musí mať aspoň 8 znakov a musí obsahovať aspoň 1 písmeno a 1 číslicu.',
          )}
          rules={[required(t), strongPassword(t)]}
        />
        <FormPasswordField
          label={t('Heslo znova')}
          name="password_confirmation"
          rules={[required(t)]}
          parentName="password"
          extra={t('Zadajte heslo znova pre potvrdenie.')}
          isConfirmationField
        />
        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey="ext_users">
            {t('Potvrdiť')}
          </FormButton>
        </FormButtonsContainer>
      </Form>
    );
  }
};

export default ForgottenPasswordForm;
